import { useRouteQuery } from '@/common/route/useRouteQuery';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useQuestTypeList } from '@/modules/quest/type/model/list';
import { questService } from '@/services/quest';

export function useQuestItemList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            typeId: { type: 'number', default: -1 }
        },
        onChange: () => fetchList()
    });

    const { questTypeOptionWithAll, fetchList: fetchQuestTypeList } = useQuestTypeList();
    const { list, total, fetchList } = useBaseListView({
        request: questService.item.list,
        paramsBuilder: () => (query.typeId === -1 ? {} : query),
        hooks: {
            loadInitialData: async () => await fetchQuestTypeList(),
            onSuccess: updateQueryToRoute,
            transformResponse: (list: any[]) =>
                list.map(item => ({
                    ...item,
                    avgGameRange: renderValueRange(item.fromAvgGame, item.toAvgGame),
                    betRange: renderValueRange(item.fromGameBet, item.toGameBet)
                }))
        }
    });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: questService.item.disable,
            onSuccess: () => fetchList()
        }),
        disableNext: crudAction.confirmAndDisable({
            request: questService.item.disableNext,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: questService.item.enable,
            onSuccess: () => fetchList()
        }),
        enableNext: crudAction.confirmAndEnable({
            request: questService.item.enableNext,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: questService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, query, questTypeOptionWithAll, actions };
}

function renderValueRange(fromValue: any, toValue: any) {
    const from = fromValue >= 0 ? `[${fromValue}, ` : '(∞, ';
    const to = toValue >= 0 ? `${toValue})` : '∞)';

    return from + to;
}
